const statusCodes = {
  100: {
    code: "100",
    label: "Prepare for submission",
  },
  200: {
    code: "200",
    label: "Ready for review",
  },
  300: {
    code: "300",
    label: "Waiting for review",
  },
  400: {
    code: "400",
    label: "Rejected",
  },
  500: {
    code: "500",
    label: "Unresolved issues",
  },
  600: {
    code: "600",
    label: "Approved",
  },
};
export { statusCodes };